import request from '@/utils/request'

export function fetchList(data) {
  return request({
    url: '/CoachAttendance/List',
    method: 'post',
    data,
  })
}

export function getItem(id) {
  return request({
    url: '/CoachAttendance/Get',
    method: 'post',
    data: { id },
  })
}

export function createItem(data) {
  // console.log('createItem', data)

  return request({
    url: '/CoachAttendance/Create',
    method: 'post',
    data,
  })
}

export function updateItem(data) {
  // console.log('updateItem', data)

  return request({
    url: '/CoachAttendance/Update',
    method: 'post',
    data,
  })
}

export function deleteItem(data) {
  return request({
    url: '/CoachAttendance/Delete',
    method: 'delete',
    data,
  })
}

export function getAttendanceCount(data) {
  return request({
    url: '/CoachAttendance/GetAttendanceCount',
    method: 'post',
    data,
  })
}

export function listAbnormal(data) {
  return request({
    url: '/CoachAttendance/ListAbnormal',
    method: 'post',
    data,
  })
}

export function acceptAbnormalAttendance(data) {
  return request({
    url: '/CoachAttendance/acceptAbnormalAttendance',
    method: 'post',
    data,
  })
}

export function rejectAbnormalAttendance(data) {
  return request({
    url: '/CoachAttendance/rejectAbnormalAttendance',
    method: 'post',
    data,
  })
}

export function submitAbnormal(data) {
  return request({
    url: '/CoachAttendance/SubmitAbnormal',
    method: 'post',
    data,
  })
}

export function listCoach(data) {
  return request({
    url: '/CoachAttendance/listCoach',
    method: 'post',
    data,
  })
}
